/*
 * @Author: tao.zong
 * @Date: 2018-11-30 11:30:14
 * @Last Modified by: tao.zong
 * @Last Modified time: 2018-12-03 16:18:14
 */
import http from "@/api/http/fetch/index";
import store from "@/store/index";
import * as types from "@/store/constants/types";
import { getFormatDate } from "@/utils/global";
import localStorageHelper from "@/localstorage/localstorage";
import GeneralUtilsHelper from "@/utils/generalUtils";
import router from "@/router/router";

const formatDay = "yyyy/MM/dd";
/* 
  随机消息的图标
  params: 图标的数组
*/
const randomIcon = (arr: any) => {
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
};
const randomNotice = (arr: any) => {
  const randNum = Math.floor(Math.random() * arr.length);
  return arr[randNum];
};
/*
 * 获取消息今天是否推送过
 * @param type 必填 存的localstrage 的title；
 */
const getNoticeTodaySendStatus = (type: string) => {
  const setDay: any = localStorageHelper.get(type);
  const nowDay = getFormatDate(new Date(), formatDay);
  return setDay === nowDay ? true : false;
};
// 不根据权重法的消息
class HanleNotAccordWeightNotice {
  private isVipToBack = false;
  //用户信息
  private vipWillExpireNotice = [
    {
      title: "Reminder: The member will expire",
      text: "🆘Orders will not be protected.",
      icon: "vip_noti_7_80",
      customData: {
        index: "slide0",
        type: "vip-will-expire-notice"
      }
    },
    {
      title: "VIP Benefit will Expire in 7 days",
      text: "You will immediately lose powerful IG growth. 🎢",
      icon: "vip_noti_7_80",
      customData: {
        index: "slide6",
        type: "vip-will-expire-notice"
      }
    },
    {
      title: "Your membership will expire! 🚨",
      text: "Renew your VIP membership to grab your FREE followers Per day.",
      icon: "vip_noti_7_80",
      customData: {
        index: "slide1",
        type: "vip-will-expire-notice"
      }
    },
    {
      title: "Renew VIP Membership 🎫",
      text: "24/7 exclusive customer service is at your service.",
      icon: "vip_noti_7_80",
      customData: {
        index: "slide10",
        type: "vip-will-expire-notice"
      }
    }
  ];
  // 回到vip页面
  private vipReturnBackIcon = [
    "vip_noti_2_80",
    "vip_noti_5_80",
    "vip_noti_6_80",
    "vip_noti_8_80"
  ];

  //今天未参加赌场，或者从未参加过赌场
  private notPlayCasinoNotice = [
    {
      title: "🚀 Boooost Followers&Likes",
      text: "Get in on the action with your FREE coins! Play Now!🤩",
      customData: {
        type: "casino-notice",
        isplay: "notplay"
      }
    },
    {
      title: "💝Sweet 2000 coins inside",
      text: "👉🏻Swipe here to stack up with your FREE gift!",
      customData: {
        type: "casino-notice",
        isplay: "notplay"
      }
    },
    {
      title: "🤑It's time for a FREE COINS! ",
      text: "WHOOP! WHOOP! Tap to win 2000 free coins!!💰💰",
      customData: {
        type: "casino-notice",
        isplay: "notplay"
      }
    },
    {
      title: "✅YOUR FREE COINS IS READY",
      text:
        "😻Free Followers, Likes, Comments.. All are waiting for you with FREE Coins!",
      customData: {
        type: "casino-notice",
        isplay: "notplay"
      }
    },
    {
      title: "💥SUPRISE💥",
      text: "👉🏻Swipe for 2000 coins! ",
      customData: {
        type: "casino-notice",
        isplay: "notplay"
      }
    }
  ];
  //今天未参加过赌场，金币小于1000
  private PlayCasinoLessCoinNotice = [
    {
      title: "‼️DOUBLE SHOT‼️",
      text: "😱Your shot to DOUBLE your coins! Play Now!",
      customData: {
        type: "casino-notice",
        isplay: "lesscoin"
      }
    },
    {
      title: "👉🏻DOUBLE your coins",
      text: "💰Win these rewards NOW! Head in now!",
      customData: {
        type: "casino-notice",
        isplay: "lesscoin"
      }
    },
    {
      title: "🤩DOUBLE your wins",
      text: "👉🏻You ONLY need 20 coins to win more followers & likes! Play Now!",
      customData: {
        type: "casino-notice",
        isplay: "lesscoin"
      }
    }
  ];

  //今天未参加过赌场，金币大于1000
  private PlayCasinoMoreCoinNotice = [
    {
      title: "💥BIG WIN COINS!💥",
      text: "🤩Still haven't entered? There's still time!",
      customData: {
        type: "casino-notice",
        isplay: "morecoin"
      }
    },
    {
      title: "💰💰Tons of Rewards💰💰",
      text: "🎁Stack up with these AMAZING rewards! Play now!",
      customData: {
        type: "casino-notice",
        isplay: "morecoin"
      }
    },
    {
      title: "🎉Epic win here!",
      text: "📣Start where you left off - Go all in!",
      customData: {
        type: "casino-notice",
        isplay: "morecoin"
      }
    },
    {
      title: "💥💰EPIC WIN is waiting for you💰💥",
      text: "👉🏻Do your bankroll a power of good! PLAY NOW!👈🏻",
      customData: {
        type: "casino-notice",
        isplay: "morecoin"
      }
    }
  ];

  public getSendNoticeContent = () => {
    //掉过这个方法，说明今天注册过一次通知了
    const nowTimeStr = getFormatDate(new Date(), formatDay);
    localStorageHelper.set("send-notice-toady", nowTimeStr);
    //先判断是否有从vip页面退到后台发的通知，如果有，则不用判断是否发送换回登录的通知
    const data1: any = this.sendCallBackToVipNotice();
    let data2 = "";
    if (!this.isVipToBack) {
      data2 = this.sendCallbackNotLoginNotice();
    }
    //vip即将过期的通知
    const data3: any = this.sendVipWillExpiredNotice();
    //赌场的通知
    const data4 = this.sendCasinoNotice();
    return data1 + data2 + data3 + data4;
  };
  private sendVipWillExpiredNotice = () => {
    let vipLeftDay = 0;
    //现在是vip，不支持自动订阅
    if (GeneralUtilsHelper.isVip()) {
      const GxUserInfo = store.getters[types.GETTER_MASTER_SERVICE_DATA];
      const findService = GxUserInfo.services.find((service: any) => {
        return service.kind === "vip";
      });
      //支持自动订阅,没购买过vip不发此类消息
      if ((findService && !findService.is_no_auto_renew)||!findService) {
        return "";
      }
      vipLeftDay = Math.ceil(
        (findService.expire - GxUserInfo.server_current_time) / 86400000
      );
      if (vipLeftDay > 7) {
        return "";
      }
      //小于或等于7说明要过期了;
      let arr = [0, 1, 2, 3, 4, 5, 6];
      arr = arr.slice(0, vipLeftDay);
      let vipPushData = "";
      for (let i = 0, len = arr.length; i < len; i++) {
        const isSendToday = getNoticeTodaySendStatus("send-notice-toady"); //为true，说明今天发送过消息了，不再注册消息
        //今天注册过了，就明天开始注册通知
        if (i === 0 && isSendToday) {
          vipPushData += "";
        } else {
          const notice = randomNotice(this.vipWillExpireNotice);
          if (notice.title.indexOf("VIP Benefit will Expire in") > -1) {
            notice.title =
              vipLeftDay - i === 1
                ? `VIP Benefit will Expire in 1 day`
                : `VIP Benefit will Expire in ${vipLeftDay - i} days`;
          }
          const timeVal = 120000 + i * 86400000;
          // const timeVal = 1200 + i * 1000;
          const pushData = {
            title: notice.title,
            content: notice.text,
            customData: notice.customData,
            timeInterval: timeVal,
            badgeNumber: 0,
            imageUrl: notice.icon
          };
          vipPushData += timeVal ? "&" + JSON.stringify(pushData) : "";
        }
      }
      return vipPushData;
    } else {
      return "";
    }
  };
  //未登录过的消息
  private sendCallbackNotLoginNotice = () => {
    //从没有登录过
    const isSendToday = getNoticeTodaySendStatus("send-notice-toady"); //为true，说明今天发送过消息了，不再注册消息
    const connection = store.getters[types.GETTER_MASTER_SERVICE_DATA];
    if (isSendToday || connection) {
      return "";
    } else {
      const pushData = {
        title: "Try Without Login!🔓",
        content: "Tap Here👆 search your IG account to get started.",
        customData: { type: "call-back-notice" },
        timeInterval: 4000,
        badgeNumber: 0
      };
      return "&" + JSON.stringify(pushData);
    }
  };
  //vip页面唤回登录
  private sendCallBackToVipNotice = () => {
    const routerCurrent = router.history.current;
    const routerName = routerCurrent.name;
    const routetype = routerCurrent.query.type;
    if (routerName === "VipCenter" && routetype === "single") {
      //是从sigle类型的vipcenter页面退到后台
      this.isVipToBack = true;
      const pushData = {
        title: "🎁 FREE VIP services 🎁",
        content: "Hey, wait! Come back and get it FREE!",
        customData: { type: "call-back-to-vip-notice" },
        imageUrl: randomIcon(this.vipReturnBackIcon),
        timeInterval: 7000,
        badgeNumber: 0
      };
      return "&" + JSON.stringify(pushData);
    } else {
      return "";
    }
  };
  //赌场通知
  private sendCasinoNotice = () => {
    const firstSendTime = localStorageHelper.get(
      "first_send_casino-notice-time"
    );
    // console.log("firstSendTime", firstSendTime);
    if (firstSendTime) {
      //firstSendTime存在，表示之前有发送过赌场的消息，通过与点击赌场通知的时间差，超过六天，表示客户连续三次未点，
      const clickCasinoNoticeTime = localStorageHelper.get(
        "click_casino-notice-time"
      );
      // console.log("clickCasinoNoticeTime", clickCasinoNoticeTime);
      if (!clickCasinoNoticeTime) {
        //未点击过赌场通知
        const timeDiff =
          (new Date().getTime() - firstSendTime) / 24 / 3600 / 1000;
        // console.log("未点击过通知 timeDiff", timeDiff);
        if (timeDiff > 6) {
          //连续三天未点击，不再发送赌场通知
          return "";
        }
      } else {
        //点击过，又当做第一次发送赌场通知，记录发送时间
        localStorageHelper.set(
          "first_send_casino-notice-time",
          new Date().getTime()
        );
        const timeDiff =
          (new Date().getTime() - firstSendTime) / 24 / 3600 / 1000;
        // console.log("有点击过通知 timeDiff", timeDiff);
        if (timeDiff > 6) {
          //连续三天未点击，不再发送赌场通知
          return "";
        }
      }
    } else {
      localStorageHelper.set(
        "first_send_casino-notice-time",
        new Date().getTime()
      );
    }

    const hasPlay = getNoticeTodaySendStatus("is_play_casino");
    let casinoPushData = "";
    if (hasPlay) {
      //今天玩过赌场
      const totalCoin = store.getters[types.GETTER_MASTER_COINS];
      if (totalCoin >= 1000) {
        casinoPushData = this.getCasinoNoticeContent(
          this.PlayCasinoMoreCoinNotice
        );
      } else {
        casinoPushData = this.getCasinoNoticeContent(
          this.PlayCasinoLessCoinNotice
        );
      }
    } else {
      //今天没玩过赌场
      casinoPushData = this.getCasinoNoticeContent(this.notPlayCasinoNotice);
    }
    return casinoPushData;
  };
  private getCasinoNoticeContent = (noticeArr: any[]) => {
    //一次注册三条消息，第二天，第四天，第六天十点发
    const arr = [0, 2, 4];
    //当天零点的时间戳
    // let noticeTime = 0;
    const todayZero = new Date(new Date().toLocaleDateString()).getTime();
    //算出距离第二天10点的时间；
    const todayToten =
      todayZero + 24 * 3600 * 1000 - new Date().getTime() + 10 * 3600 * 1000;
    let dataStr = "";
    for (const val of arr) {
      const notice = randomNotice(noticeArr);
      const noticeTime = val * 24 * 3600 * 1000 + todayToten;
      // noticeTime += 2000;
      const casinoData = {
        title: notice.title + " ".repeat(val / 2),
        content: notice.text,
        customData: notice.customData,
        timeInterval: noticeTime,
        badgeNumber: 0
      };
      dataStr += noticeTime ? "&" + JSON.stringify(casinoData) : "";
    }
    return dataStr;
  };
}
const hanleNotAccordWeightNotice = new HanleNotAccordWeightNotice();
export default hanleNotAccordWeightNotice;
